import * as React from 'react';

import * as styles from './ChatMessageChatbotGreeting.css';
import { ImageNode } from './ImageNode';
import { useMessageText } from '../../containers/ChatMessageContainer/hooks';
import { EMessageContentType } from '../../types/messageContentType';
import { EMessageType } from '../../types/messageType';
import { TMessage, TOutcomingStatus } from '../../types/messages';
import { ChatMessageContent } from '../ChatMessageContent';

type TChatMessageChatbotGreeting = {
  message: TMessage & { status: TOutcomingStatus };
  isLastInChain: boolean;
  messageId: string;
};

export const ChatMessageChatbotGreeting = React.forwardRef<HTMLDivElement, TChatMessageChatbotGreeting>(
  function ChatMessageChatbotGreeting({ message, isLastInChain, messageId }, ref) {
    const { images } = message;

    const formattedText = useMessageText({ message, messageId });

    return (
      <ChatMessageContent
        messageType={EMessageType.Incoming}
        isLastMessageInChain={isLastInChain}
        imageMessage={images?.[0] && <ImageNode src={images[0]} />}
        textMessage={<div className={styles['text']}>{formattedText}</div>}
        contentType={EMessageContentType.ImageWithText}
        userName={null}
        documentMessage={null}
        errorSign={null}
        errorText={null}
        messageMeta={null}
        actionButtons={null}
        offerMessage={null}
        imageAsDocumentMessage={null}
        bubbles={null}
        ref={ref}
      />
    );
  },
);
